module.exports = __webpack_public_path__ + "static/media/soup.7c1c7e1f.svg";